import { BaseElements, BaseObject, BaseService, BaseInjector } from '../../../js/base';
import { EmptyNodeList, querySelectorAll } from '../../../utility/utils/index';

const PASSWORD_REGEXP = '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[.*&^%@!]).{10,}$';

class Texts extends BaseObject {
    passwordWrongFormat = 'A password must contain an uppercase letter, a number and a special character (., *, &, ^, %, @, !) and must be at least 10 chars long';
}

class ClassList extends BaseObject {
    displayNone = 'd-none';
    displayFlex = 'd-flex';
    isValid = 'is-valid';
    isInvalid = 'is-invalid';
}

class Selectors extends BaseObject {
    form = 'form';
    passwordInputFormatValidate = '.js-format-validate';
}

class Elements extends BaseElements<Selectors> {
    passwordInputs: NodeListOf<HTMLInputElement> = new EmptyNodeList();
    constructor(selectors: Selectors) {
        super(selectors, true);
    }

    initElements() {
        this.passwordInputs = querySelectorAll(this.selectors.passwordInputFormatValidate);
    }
}

interface PasswordFormatValidation extends BaseService<Selectors, Elements, ClassList, Texts> { }

@BaseInjector(Selectors, Elements, ClassList, Texts)
class PasswordFormatValidation {

    invalid = {
        passwordFormat: false
    }

    initialize(): void {
        if (!this.elements.passwordInputs) { return }
        this.addEventListeners();
    }

    addEventListeners(): void {

        this.elements.passwordInputs.forEach(passwordInput => {
            passwordInput.addEventListener('change', this.onChangePassword.bind(this));
        });
    }

    onChangePassword() {
        this.checkPasswordFormat();
    }

    checkPasswordFormat() {
        const password = this.elements.passwordInputs[0].value;
        if (!!password) {
            let regexp = new RegExp(PASSWORD_REGEXP, 'gm');
            this.elements.passwordInputs[0].classList.remove(this.classList.isInvalid);
            this.destroyTooltip(this.elements.passwordInputs[0]);
            this.invalid.passwordFormat = false;

            if (!regexp.test(password)) {
                this.elements.passwordInputs[0].classList.add(this.classList.isInvalid);
                this.setTooltip(this.elements.passwordInputs[0], this.texts.passwordWrongFormat);
                this.invalid.passwordFormat = true;
            }

            return !this.invalid.passwordFormat;
        }
    }

    setTooltip(el, text) {
        el.dataset.toggle = 'tooltip';
        el.setAttribute('title', text);
        $(el).tooltip()
    }

    destroyTooltip(el) {
        el.setAttribute('title', '');
        $(el).tooltip('dispose')
    }

}

export default PasswordFormatValidation;

export {
    Elements as PasswordFormatValidationElements,
    Selectors as PasswordFormatValidationSelectors,
    ClassList as PasswordFormatValidationClassList,
    Texts as PasswordFormatValidationTexts
}